let scriptPromise = null;

// Loads the Google Pay script at most once, no matter how many
// components/instances call this concurrently.
export default function init() {
  if (window.google?.payments?.api) {
    return Promise.resolve(window.google);
  }

  if (!scriptPromise) {
    scriptPromise = new Promise((resolve, reject) => {
      const script = document.createElement("script");
      script.async = true;
      script.src = "https://pay.google.com/gp/p/js/pay.js";
      script.onload = () => resolve(window.google);
      script.onerror = (error) => {
        scriptPromise = null;
        reject(error);
      };
      document.querySelector("head").appendChild(script);
    });
  }

  return scriptPromise;
}
